import type { EntryPoint } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type ModalEntryPointFixture from '../modal-ui';

export const loadingModalEntryPoint: EntryPoint<typeof ModalEntryPointFixture, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<typeof ModalEntryPointFixture>(
			// Intentionally unresolved so the documentation keeps showing the loading state.
			() => new Promise<typeof ModalEntryPointFixture>(() => undefined),
			{ moduleId: 'constellation-loading-modal-entry-point' },
		),
		getPreloadProps: () => ({}),
	});
